module.exports = __webpack_public_path__ + "static/media/idull-fitri-web.0450ec07.jpg";